import localeDe from '@angular/common/locales/de';
import { registerLocaleData } from '@angular/common';
import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { AppComponent } from './app.component';
import { appRoutes } from './app.routes';
import { appTranslations } from './app.translations';
import { DekraDesignSystemModule, setDefaultLocale, useLocale } from '@dekra-ds/angular';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { provideRouter, RouterModule } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { DekraCostToolClientModule, DekraCostToolClientService } from '@dekra-api/cost-tool-client';
import { environment } from '../environments/environment';

registerLocaleData(localeDe);

@NgModule({
  declarations: [
    AppComponent,
    FooterComponent,
    HeaderComponent,
    LandingPageComponent,
  ],
  imports: [
    BrowserModule,
    DekraCostToolClientModule,
    DekraDesignSystemModule.forRoot(),
    RouterModule,
    TranslateModule.forRoot(),
  ],
  providers: [
    {provide: LOCALE_ID, useValue: 'de'},
    provideHttpClient(withInterceptorsFromDi()),
    provideRouter(appRoutes),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(backend: DekraCostToolClientService, translate: TranslateService) {
    backend.setBaseUrl(environment.backendUrl);
    translate.setTranslation('de', {'BUI': appTranslations.de}, true);
    translate.setFallbackLang('de');
    translate.use('de');
    setDefaultLocale('de');
    useLocale('de');
  }
}
